import { createFileRoute } from "@tanstack/solid-router";
import { usePageTitle } from "../../hooks/usePageTitle";

export const Route = createFileRoute("/settings/")({
  component: RouteComponent,
});

function RouteComponent() {
  usePageTitle("Innstillinger");

  return <div>Hello "/settings/"!</div>;
}
